import { render, staticRenderFns } from "./PreviewAppointment.vue?vue&type=template&id=72e73a0e&"
import script from "./PreviewAppointment.vue?vue&type=script&lang=js&"
export * from "./PreviewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAppointment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports